import { Loader2 } from "lucide-react";

import { HealthlinkXsltFrame } from "features/healthlink/components/HealthlinkXsltFrame/HealthlinkXsltFrame";

import styles from "./ResultHl7Preview.module.css";

/**
 * The styled HL7 document for one opened result (KIN-2120).
 *
 * `document` comes from useResultHl7Document in the panel above, which also decides
 * whether its own structured fallback needs loading — so the two can't disagree about
 * whether there is a preview.
 *
 * `fallback` is whatever that panel shows when there is no document to render.
 */
export const ResultHl7Preview = ({ document, documentKind, fallback = null }) => {
  if (document?.isLoading) {
    return (
      <div className={styles.loadingState}>
        <Loader2 className={styles.loadingSpinner} size={24} />
        <p>Loading message…</p>
      </div>
    );
  }

  if (!document?.hasPreview) return fallback;

  return (
    <HealthlinkXsltFrame
      xml={document.xml}
      xsl={document.xsl}
      documentKind={documentKind}
    />
  );
};
